import React from "react";
import { Button, Grid, Tab, Label } from "semantic-ui-react";
import OverView from "./OverView";
import "./styles.css";

const panes = [
  { menuItem: "OVERVIEW", pane: { key: "tab1", content: <OverView /> } },
  {
    menuItem: "PROMOTIONS",
    pane: {
      key: "tab2",
      content: <div>Tab2</div>
    }
  },
  {
    menuItem: "INSIGHTS",
    pane: {
      key: "tab3",
      content: (
        <div>
          This tab contains an <Label>JSX</Label> element
        </div>
      )
    }
  }
];

class Loyalty extends React.Component {
  render() {
    return (
      <div className="tabs-container">
        <Tab panes={panes} renderActiveOnly={false} />
        <div className="create-new-btn-cont">
          <Button
            onClick={() => this.props.history.push("/dashboard/setup-loyalty")}
            className="create-new-btn"
          >
            Create New
          </Button>
        </div>
      </div>
    );
  }
}

export default Loyalty;



// WEBPACK FOOTER //
// ./src/containers/Loyalty/index.js